import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SidebarModule } from 'primeng/sidebar';
import { FooterModule } from './components/footer/footer.module';
import { HeaderModule } from './components/header/header.module';
import { MenuModule } from './components/menu/menu.module';
import { SideMenuModule } from './components/side-menu/side-menu.module';
import { LayoutComponent } from './layout.component';
const PRIMENG_MODULES = [PanelMenuModule, SidebarModule, BreadcrumbModule];
@NgModule({
  declarations: [LayoutComponent],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    HeaderModule,
    FooterModule,
    MenuModule,
    SideMenuModule,
    ...PRIMENG_MODULES,
  ],
  exports: [LayoutComponent, HeaderModule, FooterModule, MenuModule],
})
export class LayoutModule {}
